import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormControlErrorComponent } from './form-control-error/form-control-error.component';
import { FormErrorAlertComponent } from './form-error-alert/form-error-alert.component';
import { ClearFormButtonComponent } from './clear-form-button/clear-form-button.component';
import { FormGroup } from './form-group/form-group.class';
import { FormComponent } from './form/form.component';
import { CustomErrorMessage } from './models/custom-error-message.interface';
import { LABEL_POSITION } from './enums/label-position.enum';
import { EdAssistUIButtonModule } from '@edassist-ui/button';
import { FORM_CONSTANTS } from './constants/form.constants';
import { EdAssistUIAlertModule } from '../alert';
import { FormRequiredInstructionsComponent } from './form-required-instructions/form-required-instructions.component';

const COMPONENTS = [
	FormControlErrorComponent,
	FormErrorAlertComponent,
	FormComponent,
	ClearFormButtonComponent,
	FormRequiredInstructionsComponent
];

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		EdAssistUIButtonModule,
		EdAssistUIAlertModule
	],
	exports: COMPONENTS,
	declarations: COMPONENTS
})
class EdAssistUIFormsModule {}

export {
	EdAssistUIFormsModule,
	FormControlErrorComponent,
	FormErrorAlertComponent,
	FormComponent,
	FormGroup,
	CustomErrorMessage,
	LABEL_POSITION,
	FormRequiredInstructionsComponent,
	FORM_CONSTANTS
};
